<template>
    <div>
        <dv-full-screen-container style="background-color: #1B1534">

            <div class="d-flex flex-row mb-3 justify-content-start align-items-center w-100"
                 style="height: 8%" @click="switchScreenFull">
                <dv-decoration-11 class="dv-card-title h-100" style="width:20%;font-size: 2rem">
                    SITH生产看板
                </dv-decoration-11>
                <p class="dv-card-title" style="font-size: 2rem;margin-left: 5%">安全生产</p>
                <div class="date-card" :key="i" v-for="(num,i) in safetyDays">
                    <p class="date-card-number">{{ num }}</p>
                </div>
                <p class="dv-card-title" style="font-size: 2rem">天</p>
                <p class="ml-auto p-2 dv-card-title" style="font-size: 1.4rem">自</p>
                <p class="dv-card-title" style="font-size: 1.6rem;color: #08e5ff">{{ safetyDateFrom }}</p>
                <p class="dv-card-title p-2" style="font-size: 1.4rem">至</p>
                <p class="dv-card-title" style="font-size: 1.6rem;color: #08e5ff">{{ datetime.substring(0, 11) }}</p>
                <p class="dv-card-title p-2" style="font-size: 1.6rem">{{ datetime.substring(11, 19) }}</p>
                <dv-decoration-8 :reverse="true" style="width:15%;height:60%;"/>
            </div>

            <div class="row" style="height: 92%">
                <div class="col-3 h-100">
                    <div class="row d-flex justify-content-center w-100 svg-cover" style="height: 5%;">
                        <TitleCover style="width:50%;height:100%;">
                            <p class="dv-card-title">工位/人员状态</p>
                        </TitleCover>
                    </div>
                    <div class="row" style="height: 45%;">
                        <WorkerStatusScroll v-if="vIfLazyLoad" :code="workshopCodeIndex"></WorkerStatusScroll>
                    </div>
                    <div class="row d-flex justify-content-center w-100 svg-cover" style="height: 5%;margin-top: -10%">
                        <TitleCover style="width:50%;height:100%;">
                            <p class="dv-card-title">项目进度</p>
                        </TitleCover>
                    </div>
                    <div class="row" style="height: 45%;">
                        <ProgramProcessScroll style="height: 100%"></ProgramProcessScroll>
                    </div>
                </div>
                <div class="col-9 h-100">
                    <div class="row" style="height: 63%">
                        <div class="col-6 h-100">
                            <div class="row d-flex justify-content-center w-100 svg-cover" style="height: 10%">
                                <TitleCover class="fill" style="z-index: 9999">
                                    <p class="dv-card-title p1">{{ workshops[currentWorkshop] }}</p>
                                </TitleCover>
                            </div>
                            <div class="row" style="height: 70%;width: 98%;margin: -10% 1% 0 1%">
                                <dv-border-box-10 style="height: 100%;">
                                    <el-carousel height="100%" style="height: 100%" @change="carousel"
                                                 :indicator-position="indicatorPosition"
                                                 :arrow="arrow">
                                        <template v-for="index in 4">
                                            <el-carousel-item :key="index" v-if="wsEnable[index-1]">
                                                <TheMap :map-code="getWorkShopCode(index)"></TheMap>
                                            </el-carousel-item>
                                        </template>
                                    </el-carousel>
                                </dv-border-box-10>
                            </div>
                            <div class="row d-flex justify-content-center w-100 svg-cover" style="height: 10%;">
                                <TitleCover class="fill">
                                    <p class="dv-card-title">当月计划/实际对比</p>
                                </TitleCover>
                            </div>
                            <div class="row mt-1 d-flex align-items-center" style="height: 16%">
                                <div class="col-6 h-100">
                                    <div class="row fill">
                                        <div class="col-4 h-100">
                                            <div class="row" style="height: 50%">
                                                <p class="dv-card-title m-auto" style="color: white">工时负荷</p>
                                            </div>
                                            <div class="row" style="height: 50%">
                                                <p class="dv-card-title m-auto" style="color: white">完成率</p>
                                            </div>
                                        </div>
                                        <div class="col-8 h-100">
                                            <dv-percent-pond ref="planRate" :config="rateConfig" class="h-100 w-100"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="row w-100" style="height: 33%">
                                        <p class="dv-card-title title-a">计划标准工时</p>
                                        <p class="numbers ml-auto mr-0 p-2 bd-highlight">{{ planHour }}小时</p>
                                        <p class="ml-1 pt-3 number-sub">含服务{{ hoursOf1SI.planHour }}H</p>
                                    </div>
                                    <div class="row w-100" style="height: 33%">
                                        <p class="dv-card-title title-a">实际上工工时</p>
                                        <p class="numbers ml-auto mr-0 p-2 bd-highlight">{{ workHour }}小时</p>
                                        <p class="ml-1 pt-3 number-sub">含服务{{ hoursOf1SI.workHour }}H</p>
                                    </div>
                                    <div class="row w-100" style="height: 33%">
                                        <p class="dv-card-title title-a">完成计划工时</p>
                                        <p class="numbers ml-auto mr-0 p-2 bd-highlight">{{ finishPlanHour }}小时</p>
                                        <p class="ml-1 pt-3 number-sub">含服务{{ hoursOf1SI.finishPlanHour }}H</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6 h-100">
                            <div class="row w-100" style="height: 50%">
                                <OTDChart class="fill"></OTDChart>
                            </div>
                            <div class="row w-100" style="height: 50%">
                                <div class="col-5 d-flex align-items-start flex-column h-100">
                                    <div class="row mt-auto w-100 svg-cover" style="height:10%;">
                                        <TitleCover class="w-100 h-100">
                                            <p class="dv-card-title">月度生产负荷</p>
                                        </TitleCover>
                                    </div>
                                    <div class="row w-100" style="height: 90%;">
                                        <MonthOutput class="w-100 h-100"></MonthOutput>
                                    </div>
                                </div>
                                <div class="col-7 h-100">
                                    <SingleInspectionQualifyChart class="fill"></SingleInspectionQualifyChart>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex justify-content-around" style="height: 37%">
                        <div class="col h-100">
                            <AndonRespondRate :code="workshopCodeIndex" class="h-100"></AndonRespondRate>
                            <p class="float-above p2">单位：min</p>
                        </div>
                    </div>
                </div>
            </div>

        </dv-full-screen-container>

    </div>
</template>

<script>
import WorkerStatusScroll from "@/components/echarts-part/kpi/sith/cells/WorkerStatusScroll";
import ProgramProcessScroll from "@/components/echarts-part/kpi/sith/cells/ProgramProcessScroll";
import MonthOutput from "@/components/echarts-part/kpi/sith/cells/MonthOutput";
import AndonRespondRate from "@/components/echarts-part/kpi/sith/cells/AndonRespondRate";
import screenfull from 'screenfull'
import EmCommonApi from "@/mixin/em/common/api";
import moment from "moment";
import {_pxGenerator, getOrDefault} from "../../../LayoutMaps/maps/MapFunction";
import OTDChart from "./cells/charts/OTDChart";
import SingleInspectionQualifyChart from "./cells/charts/SingleInspectionQualifyChart";
import TitleCover from "./cells/TitleCover";
import TheMap from "@/components/LayoutMaps/maps/TheMap";
import {_getWorkshopCode} from "@/components/echarts-part/kpi/sith/cells/CodeToName";

export default {
    name: "KpiLayoutOldVersion",
    mixins: [EmCommonApi],
    components: {
        TheMap,
        TitleCover,
        SingleInspectionQualifyChart,
        OTDChart,
        AndonRespondRate,
        MonthOutput,
        ProgramProcessScroll,
        WorkerStatusScroll,
    },
    data() {
        return {
            datetime: '',
            safetyDays: [],
            safetyDateFrom: '',
            rateConfig: {},
            planHour: 0,
            workHour: 0,
            finishPlanHour: 0,
            hoursOf1SI: {
                planHour: 0,
                workHour: 0,
                finishPlanHour: 0,
            },
            workshops: ['转子车间', '机加车间', '组装车间', '试验中心'],
            currentWorkshop: 0,
            wsEnable: [true, true, true, true],
            indicatorPosition: '',
            arrow: 'hover',
            workshopCodeIndex: 0,
            refresh: {
                everySecond: {},
                everyHour: {}
            },
            vIfLazyLoad: false,
            subscribeWorkHourRefresh: {
                id: 'kpiWorkHourRefresh',
                topic: 'kpi/workHour/refresh',
                callback: (payload) => {
                    this.unpackOpPlanningHours(JSON.parse(payload.body));
                }
            },
            subscribeWorkShopData: {
                id: 'workshopData',
                topic: 'kpi/workshop/data',
                callback: (payload) => {
                    this.$store.dispatch('kpiLayout/unpackData', JSON.parse(payload.body));
                }
            }
        }
    },
    created() {
        if (!screenfull.isFullscreen) {
            screenfull.toggle()
        }
        this.setVisible(false)
        this.workshopFilter()
    },
    mounted() {
        this.fnResize()
        window.addEventListener('resize', this.fnResize, false)
        this.getSafetyDate()
        this.getOpPlanningHours()
        this.getWorkShopData();
        this.intervals()
        setTimeout(() => this.vIfLazyLoad = true, 2000);
        this.subscribeChannels();//订阅
    },
    beforeDestroy() {
        this.setVisible(true)
        this.clearIntervals()
        window.removeEventListener('resize', this.fnResize, false)
        document.documentElement.style.fontSize = '16px';
        this.unsubscribeChannels();//取消订阅
    },

    methods: {
        intervals() {
            this.refresh.everySecond = setInterval(() => {
                this.datetime = moment(new Date()).format(this.$t("em.datetime.format.viewMode"))
            }, 1000);

            this.refresh.everyHour = setInterval(() => {
                this.getSafetyDate()
                // this.getOpPlanningHours()
            }, 3600 * 1000);
        },
        clearIntervals() {
            clearInterval(this.refresh.everySecond);
            clearInterval(this.refresh.everyHour);
        },
        //订阅websocket
        subscribeChannels() {
            this.$webSocket.subscribeToBroadcast(this.subscribeWorkHourRefresh);
            this.$webSocket.subscribeToBroadcast(this.subscribeWorkShopData);
        },
        unsubscribeChannels() {
            this.$webSocket.unsubscribeToBroadcast(this.subscribeWorkHourRefresh.id);
            this.$webSocket.unsubscribeToBroadcast(this.subscribeWorkShopData.id);
        },
        switchScreenFull() {
            screenfull.toggle();
            this.fnResize()
        },
        workshopFilter() {
            let index = parseInt(this.$route.params.index);
            this.workshopCodeIndex = index;
            if (index >= 1 && index <= 4) {
                this.currentWorkshop = index - 1;
                for (let i = 0; i < 4; i++) {
                    this.wsEnable[i] = i === index - 1;
                }
                this.indicatorPosition = 'none'
                this.arrow = 'never'
            } else {
                this.wsEnable = [true, true, true, true];
                this.indicatorPosition = ''
                this.arrow = 'hover'
            }
        },
        setVisible(visibility) {
            this.$store.commit("base/setShowHeader", visibility, {root: true});
            this.$store.commit("base/setShowSidebar", visibility, {root: true});
        },
        fnResize() {
            let deviceWidth = document.documentElement.clientWidth || window.innerWidth;
            document.documentElement.style.fontSize = (deviceWidth / 125) + 'px';
        },
        carousel(index) {
            this.currentWorkshop = index
        },
        getSafetyDate() {
            let self = this;
            const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesMstLocation")}/sithMesPrdEhs/lastDate`
            this.$_emApiMixin_get(_api, false).then(value => {
                let dateStr = moment(value).format(this.$t("em.date.format.viewMode"))
                self.safetyDateFrom = dateStr
                let date_cal = (new Date().getTime() - new Date(dateStr).getTime()) / (3600 * 1000 * 24) - 1
                self.safetyDays = [];
                while (date_cal >= 1) {
                    date_cal = Math.floor(date_cal)
                    self.safetyDays.push(date_cal % 10);
                    date_cal /= 10
                }
                self.safetyDays.reverse()
            })
        },
        getOpPlanningHours() {
            const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesPrdPpOperation")}/sithMesPrdPpOperation/kpiHours`
            this.$_emApiMixin_get(_api, false).then(value => {
                this.unpackOpPlanningHours(value);
            })
        },
        unpackOpPlanningHours(value) {
            this.planHour = getOrDefault('totalForecastHour', value, 0);
            this.workHour = getOrDefault('actualWorkHour', value, 0);
            this.finishPlanHour = getOrDefault('finishPlanHour', value, 0);

            this.hoursOf1SI.planHour = getOrDefault('totalForecastHour1SI', value, 0);
            this.hoursOf1SI.workHour = getOrDefault('actualWorkHour1SI', value, 0);
            this.hoursOf1SI.finishPlanHour = getOrDefault('finishPlanHour1SI', value, 0);
            this.rateConfig = {
                value: (this.finishPlanHour * 100 / this.planHour).toFixed(1),
                borderWidth: _pxGenerator(0.05),
                borderRadius: _pxGenerator(0.1),
                borderGap: _pxGenerator(0.1)
            };
        },
        getWorkShopCode(index) {
            return _getWorkshopCode(index);
        },
        getWorkShopData() {
            const _api = `${this.$_emApiMixin_moduleBaseApi("sithMesMstWorkshop")}/sithMesMstWorkshop/kpi/workshopStatus`
            this.$_emApiMixin_post(_api, {
                code: _getWorkshopCode(0)
            }, false).then(value => {
                this.$store.dispatch('kpiLayout/unpackData', value.data);
            })
        },
    }
}
</script>

<style scoped>
.dv-card-title {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 1.5rem;
    color: #7ec699;
    font-weight: 700;
    margin: auto 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.date-card {
    background-color: rgba(4, 49, 128, .6);
    height: 5.5rem;
    width: 5.5rem;
    margin: auto;
    padding: 0
}

.date-card-number {
    color: #08e5ff;
    font-size: 2.8rem;
    font-weight: bold;
    text-align: center;
    margin: 0.5rem
}

.numbers {
    position: relative;
    overflow: hidden;
    border-radius: 0.375rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #00ffc4;
    font-weight: 700;
    font-size: 1.5rem;
    margin: auto;
}

.fill {
    width: 100%;
    height: 100%;
}

.w-100 >>> text {
    font-size: 1.6rem;
}

.float-above {
    position: absolute;
    z-index: 9999;
}

.p1 {
    left: 2rem;
    top: 1rem;
    color: #7ec699;
    font-size: 2rem !important;
}

.p2 {
    right: 1rem;
    bottom: 0;
    color: #1294fb;
    font-size: 1rem
}

.svg-cover {

}

.dv-card-title.title-a {
    font-size: 1.2rem;
    color: white;
}

.number-sub {
    color: #6df9c6;
    font-size: 1rem;
    font-weight: bold;
}

</style>